/**
 * @voltxampere/ui — TSL2561 ambient light sensor variant (Sprint 43-6, Sprint 48-7 activated)
 *
 * Sprint 48-7 — Sprint 43 placeholder activated. I2C 7-bit slave at
 * address 0x39 (default; pin-strapped 0x29 / 0x49). 16-bit dual-channel
 * ADC (visible + IR). Sensor activation layer reads:
 *   - register 0x0A (ID) → constant 0x50
 *   - register 0x0C (DATA0L) + 0x0D (DATA0H) → 16-bit visible+IR
 *   - register 0x0E (DATA1L) + 0x0F (DATA1H) → 16-bit IR-only
 *
 * Reference: ams TSL2561T datasheet (rev 2.1, 2009).
 *
 * Engine zero-diff invariant honored — schemaType stays
 * `voltage-source` for analog Vcc-rail drive; I2C bus interaction
 * lives at the sensor activation layer via I2cBusFsm helper.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorTsl2561 = {
    id: "tsl2561",
    nameTr: "TSL2561 (I2C Ambiyans Işık Sensörü)",
    nameEn: "TSL2561 (I2C Ambient Light Sensor)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "TSL2561",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 3.3,
        // Sprint 48-7 — I2C activation metadata (consumed by sensor
        // activation layer, not engine MNA).
        i2cAddress: 0x39,
        i2cFrequency: 100_000,
        sensorIdRegister: 0x0a,
        sensorIdValue: 0x50,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-tsl2561.js.map